import React from "react";
export default (({
  styles = {},
  ...props
}) => <svg width="36" height="36" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}><path fillRule="evenodd" clipRule="evenodd" d="M12 29a1 1 0 01-1 1H7a1 1 0 01-1-1V7a1 1 0 011-1h4a1 1 0 110 2H8v20h3a1 1 0 011 1z" fill="#151D51" /><path d="M26.393 12.607L31.788 18l-5.393 5.393M30 18H15" stroke="#151D51" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" /></svg>);